import { render, staticRenderFns } from "./view-files-other-notes.vue?vue&type=template&id=5c04c9a4"
import script from "./view-files-other-notes.vue?vue&type=script&lang=js"
export * from "./view-files-other-notes.vue?vue&type=script&lang=js"
import style0 from "./view-files-other-notes.vue?vue&type=style&index=0&id=5c04c9a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports